const companyLogoMap: Record<string, string> = {
  'Churchwood Stanley': 'churchwoodstanley.png',
  'Patrick James': 'patrick james.png',
  'Trenter Bacon': 'trenter bacon.png',
  'Julien Lawrence Surveying': 'jls.png',
  'Weston and Edwards': 'weston and edwards.png',
  'Schofield Removals': 'schofield removals.png',
  'Neil Marsden Associates': 'neil marsden.png',
  'Colchester Timber and Damp': 'colchester timber and damp.png',
  'TLC Environmental Services Ltd': 'tlc environmental services.png',
  'Suffolk Asbestos Solutions': 'suffolk asbestos solutions.png',
  'Creasey Drainage': 'creasey drainage.png',
  'Mersea Drains': 'mersea drains.png',
  'Real Clean': 'real estate cleaning.png',
  'Holistic Cleaning': 'holistic cleaning services.png',
  'Rhodda & Co': 'rhodda and co.png',
  'Harwich Village Homes': 'harwich village.png',
  'PRO-LEC': 'pro-lec.png',
  'Heritage Consulting Chartered Surveyors':
    'heritage consulting chartered surveyors.png',
  'Essex EPC Solutions': 'essex epc solutions.png',
  'Effective EPC': 'effective epc.png',
  'Energy Evaluations and Solutions':
    'energy evaluations and solutions.png',
  'Oyster Energy': 'oyster energy.png',
  'EPC Services Ipswich': 'epc services ipswich.png',
  Chidea: 'chidea.png',
  'Adrian Bunting': 'adrian bunting.png',
  'Phil Le Grice': 'phil le grice.png',
  'A&A Maintenance': 'a a maintenance.png',
  JDEPS: 'jdeps.png',
  'JTS Property Maintenance': 'jts property maintenance.png',
  'Jackson Mortgage Brokers': 'jackson mortgage brokers.png',
  'Paveys Estate Agents': 'paveys.png',
  'Stour Valley Plumbing and Heating': 'stour valley plumbing.png',
  'GH Heating Services': 'gh heating.png',
  Finbra: 'finbra.png',
  'BPM Essex': 'bpm essex.png',
  Ashbee: 'ashbee.png',
  'John Alexander Estate Agents': 'john alexander.png',
  'Hayward Moon': 'hayward moon.png',
  'Kerseys Solicitors': 'kerseys.png',
  Ellisons: 'ellisons.png',
  Maljon: 'maljon.png',
  Hyltreat: 'hyltreat.png',
  'Tony Flower and Associates Ltd': 'tony flower.png',
  'Ashbee Solutions': 'ashbee.png',
  'Asbestos Removal Ipswich Ltd': 'asbestos removal ipswich.png',
  'LCM Property Maintenance': 'lcm.png',
  AJS: 'ajs.png',
  'Pearson Mortgages': 'pearson.png',
  'Audrey McKenna': 'taylor rose.png',
  'Agents Choice Removals': 'acr.png',
  Remax: 'remax.png',
  'Mel Clarke': 'remax.png',
  Fentons: 'fentons.png',
  'Hazell Preservation': 'hazell.png',
  CNL: 'a a maintenance.png',
  'CNL 2': 'churchwoodstanley.png',
  'Have You Had It Surveyed.com':'have you had it surveyed.png'
};

export const getCompanyLogoPath = (companyName?: string) => {
  if (!companyName) {
    return undefined;
  }

  const fileName = companyLogoMap[companyName];
  if (!fileName) {
    return undefined;
  }

  return `/logos/${fileName}`;
};
